import { Component } from '@angular/core';
import { LandingCardComponent } from '../../../../../common/components/landing-card/landing-card.component';
import { WhyJoinContraaAnimationComponent } from './why-join-contraa-animation/why-join-contraa-animation.component';
import { TranslocoModule } from '@jsverse/transloco';
import {
  CpuSettingIconComponent,
  BrushIconComponent,
  ShareNetworkIconComponent,
  DocumentCodeIconComponent,
  SunIconComponent,
  PieChartIconComponent,
} from '@mars/ui-components';

@Component({
  selector: 'mars-why-join',
  standalone: true,
  imports: [
    LandingCardComponent,
    WhyJoinContraaAnimationComponent,
    TranslocoModule,
  ],
  templateUrl: './why-join.component.html',
  styleUrl: './why-join.component.scss',
})
export class WhyJoinComponent {
  reasons = [
    {
      title: 'landing_page_why_join_contraa_section_card_1_title',
      description: 'landing_page_why_join_contraa_section_card_1_description',
      iconComponent: CpuSettingIconComponent,
    },

    {
      title: 'landing_page_why_join_contraa_section_card_2_title',
      description: 'landing_page_why_join_contraa_section_card_2_description',
      iconComponent: BrushIconComponent,
    },

    {
      title: 'landing_page_why_join_contraa_section_card_3_title',
      description: 'landing_page_why_join_contraa_section_card_3_description',
      iconComponent: ShareNetworkIconComponent,
    },

    {
      title: 'landing_page_why_join_contraa_section_card_4_title',
      description: 'landing_page_why_join_contraa_section_card_4_description',
      iconComponent: DocumentCodeIconComponent,
    },

    {
      title: 'landing_page_why_join_contraa_section_card_5_title',
      description: 'landing_page_why_join_contraa_section_card_5_description',
      iconComponent: SunIconComponent,
    },

    {
      title: 'landing_page_why_join_contraa_section_card_6_title',
      description: 'landing_page_why_join_contraa_section_card_6_description',
      iconComponent: PieChartIconComponent,
    },
  ];
}
